import { State } from "./State";
import App from "../../../core/src/App";
import GameEvents from "../const/GameEvents";
import UIController from "../../src/ui/UIController";
import { UIStates } from "../../src/ui/UIStates";
import CommandManager from "../commands/CommandManager";
import { Commands } from "../commands/CommandEnum";
import ViewManager from "../utils/ViewManager";
import {DefaultLayers} from "../utils/Layers";

export default class SpinEndState extends State {
    public enter(): void {
        super.enter();
        UIController.setState(UIStates.SPIN_END);
        // UpdateWinCommand();
        // CommandManager.execute(Commands.UPDATE_WIN); // << should be updated in showWin, not here
        // if (!spinModel.hasFreespins()) {
        //     CommManager.send(requestRegister.get("complete_spin"), this.onResponce, this)
        // } else {
        //     Tween.delayedCall(0.2, () => {
        //         this.onResponce();
        //     });
        // }
        this.onResponse();
        // let reelGroup = ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().getSubView("ReelGroup") as CustomReelGroup;
        // reelGroup.animatePipe();
        // Tween.delayedCall(2,reelGroup.animatePipe, [true], reelGroup);
    }

    protected onResponse() {
        // TODO MOVE ALL SPIN END LOGIC HERE
        App.dispatcher.emit(GameEvents.SPIN_COMPLETE);
        this.exit();
    }
}
